import { createContext, useContext } from "react";
import { NotificationDto } from "../../types/types";

export interface NotificationsContextValue {
  notifications: NotificationDto[];
  unreadCount: number;
  /** ids of notifications whose read status is being saved right now */
  pendingIds: ReadonlySet<number>;
  refreshNotifications: (days?: number) => Promise<void>;
  toggleReadStatus: (notificationId: number) => Promise<void>;
}

export const NotificationsContext = createContext<NotificationsContextValue | null>(null);

export const useNotifications = (): NotificationsContextValue => {
  const context = useContext(NotificationsContext);

  if (!context) {
    throw new Error("useNotifications must be used inside NotificationsProvider");
  }

  return context;
};
